export const LocalStorageKeys = Object.freeze({
  CreatePlan: 'create-plan',
  CreateInvoice: 'create-invoice',
  UpdateContract: 'update-contract',
  ReviseContract: 'revise-contract',
});